import React from 'react';
import { CasePhaseHeader } from '../../case-details-layout';
import { CaseContext } from '@/context/CaseContext';
import { CreateCaseForm } from '@/components/dashboard';
import { LoaderScreen } from '@/components/common';
import { useCaseStep } from '@/hooks/useCaseStep';

export const InvestigationPhase: React.FC = () => {
	const { caseDetails } = React.useContext(CaseContext);
	const { isPhaseCompleted, caseSteps } = useCaseStep();

	const dateCompleted =
		caseSteps?.data.status?.find((step) => step.fase_name === 'Investigation')
			?.started_date ?? '';

	if (!caseDetails) return <LoaderScreen />;

	return (
		<div className="text-left space-y-8 pb-8">
			<CasePhaseHeader
				title="Case Details"
				status="approved"
				position="1"
				completedStepDate={
					isPhaseCompleted('Investigation') ? dateCompleted : ''
				}
			/>
			<div className="pl-0 md:pl-[50px]">
				<CreateCaseForm caseDetails={caseDetails} />
			</div>
		</div>
	);
};
